module.exports = "https://static.energy5.com/_next/static/images/youtube-8fe04107864760dc17d68115063f1e06.png";